import { ServerService } from '../../server/ServerService';
import { ObjectID } from 'bson';
import { API_ACTIONS } from '../../server/API_ACTIONS';

export const getBillsFromServer = ({accounts, dates}) => {
  return ServerService.postToServer('', {
    _id: new ObjectID(),
    type: API_ACTIONS.BILLS.GET,
    payload: { accounts, dates },
  })
    .then(r => {
      console.log('retour');
      return r.data;
    })
    .catch(e => {
      console.log('error during bill retrieving process');
      return [];
    });
};
